import script from "./BookingAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"

import "./BookingAnnouncementDetail.vue?vue&type=style&index=0&id=2d0a3ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0a3ff6"]])

export default __exports__